module.exports = __webpack_public_path__ + "img/blue_063.5630c411.png";